// Product description read more toggle
document.addEventListener('DOMContentLoaded', function() {
  const descriptions = document.querySelectorAll('.product-description');
  
  descriptions.forEach(function(description) {
    const fullText = description.innerHTML;
    const words = fullText.split(' ');
    
    // Only add toggle if description is longer than 50 words
    if (words.length > 50) {
      const shortText = words.slice(0, 50).join(' ') + '...';
      
      // Create wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'description-wrapper';
      
      // Create short version
      const shortDiv = document.createElement('div');
      shortDiv.className = 'description-short';
      shortDiv.innerHTML = shortText;
      
      // Create full version (hidden)
      const fullDiv = document.createElement('div');
      fullDiv.className = 'description-full';
      fullDiv.style.display = 'none';
      fullDiv.innerHTML = fullText;
      
      // Create read more button
      const readMoreBtn = document.createElement('button');
      readMoreBtn.className = 'read-more-btn';
      readMoreBtn.textContent = 'read more';
      readMoreBtn.type = 'button';
      
      // Toggle functionality
      readMoreBtn.addEventListener('click', function() {
        if (fullDiv.style.display === 'none') {
          fullDiv.style.display = 'block';
          shortDiv.style.display = 'none';
          readMoreBtn.textContent = 'read less';
        } else {
          fullDiv.style.display = 'none';
          shortDiv.style.display = 'block';
          readMoreBtn.textContent = 'read more';
        }
      });
      
      // Replace original content
      description.innerHTML = '';
      wrapper.appendChild(shortDiv);
      wrapper.appendChild(fullDiv);
      wrapper.appendChild(readMoreBtn);
      description.appendChild(wrapper);
    }
  });
});